import { Box, Button, Collapse, Stack } from '@mui/material';
import { useState } from 'react';
import { defineMessage, FormattedMessage } from 'react-intl';
import { CopyIconButton } from '../copy-btn/CopyIconButton';

const detailsToggleMessage = defineMessage({
  id: 'common.viewError.details.toggle',
  defaultMessage: 'Detalles técnicos',
});

interface ViewErrorDetailsProps {
  /** Raw backend/JS message. Hidden behind the toggle so it never becomes the main copy. */
  detail: string;
}

/**
 * Collapsible technical detail of a failed request, with a copy button so users can
 * forward the exact message (including ids) to support.
 */
export function ViewErrorDetails({ detail }: ViewErrorDetailsProps) {
  const [open, setOpen] = useState(false);

  return (
    <Box sx={{ mt: 2, width: '100%', maxWidth: 520 }}>
      <Button
        size="small"
        color="inherit"
        onClick={() => setOpen((current) => !current)}
        sx={{ typography: 'caption', color: 'text.secondary' }}
      >
        <FormattedMessage {...detailsToggleMessage} />
      </Button>

      <Collapse in={open}>
        <Stack
          direction="row"
          spacing={1}
          alignItems="flex-start"
          sx={{
            mt: 1,
            p: 1.5,
            borderRadius: 1,
            bgcolor: 'action.hover',
            textAlign: 'left',
          }}
        >
          <Box
            sx={{
              typography: 'caption',
              fontFamily: 'monospace',
              color: 'text.secondary',
              wordBreak: 'break-word',
              flexGrow: 1,
            }}
          >
            {detail}
          </Box>
          <CopyIconButton copyValue={detail} />
        </Stack>
      </Collapse>
    </Box>
  );
}
